module.exports = __webpack_public_path__ + "static/media/image0030.2b1de21e.jpg";